var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['content', { regulation: ((_vm.stop == null) ? false : _vm.stop.isRegulationStop) }]},[_vm._v(" "+_vm._s(_vm.getStopTime())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }